
(function($s){

    $.avoidDoubleClick = function() {
        $('input.btn, button.btn').bind('dblclick', function () {
            return false;
        });
    }

    $.bindSubmitEvent = function(forms) {
        $(forms).bind('submit', function () {
            if(!$(this).attr('target')) {
                $('input.btn, button.btn').hide();
                $('select, textarea, input').attr('readonly', 'readonly');
                $(this).css('opacity', 0.3);
                $('#unsaved-form-data-notify').modal('hide');
                $('#save-form-data-notify').modal('show');
            }
            return true;
        });
    }

    $.initUploadFields = function() {
        $('input.form-control-upload').bind('change', function () {
            if ($(this).prop("files")[0]['type'].match(/image/ig)) {
                preview = '<img style="width:auto;height:26px;" id="' + $(this).attr('id') + '_preview_img" class="img-fluid mr-1">';
                $('label#' + $(this).attr('id') + '_label').html(preview + $(this).prop("files")[0]['name']);
                $.readUploadFileURL(this);
            }
            else {
                $('label#' + $(this).attr('id') + '_label').html($(this).prop("files")[0]['name']);
            }
        });
    }

    $.initAutocompleteFields = function () {
        $.each($('input.cheers-autocomplete'), function(i, field) {
            let _serviceUrl = $(field).attr('data-ac-url');
            let _target = $(field).attr('data-ac-target');
            let _max = parseInt($(field).attr('data-ac-max'));
            $(field).autocomplete({
                minChars: 1,
                serviceUrl: _serviceUrl,
                type: 'GET',
                dataType: 'json',
                paramName: 'filter[s]',
                params: {filter: {max: _max}},
                onSearchError: function(query, jqXHR, textStatus, errorThrown) {
                    return {query: query, suggestions: {value: '', data: ''}};
                },
                onSelect: function (suggestion) {
                    $(_target).val(suggestion.data);
                    $(this).val(suggestion.value);
                }
            });
        });
    }

    $.initPopovers = function () {
        $('[data-toggle="popover"]').popover();
        $('body').on('click', function (e) {
            $('[data-toggle="popover"]').each(function () {
                if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                    $(this).popover('hide');
                }
            });
        });
    }

    $.readUploadFileURL = function(input) {
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = function (e) {
                $('#'+input.id+'_preview_img').attr('src', e.target.result);
            }
            reader.readAsDataURL(input.files[0]);
        }
    }

    $.handleModalFormStatus = function (theForm, statusName, successMsg, errorMsg, errors) {

        switch(statusName) {
            case "processing":
                $(theForm).find('.form-content').hide();
                $(theForm).find('.form-errors').hide();
                $(theForm).find('.form-proccessing').show();
                $(theForm).find('.model-footer button, button[type="submit"]').hide();
                break;
            case "done":
                if(successMsg) {
                    $(theForm).find('.form-success .message').html(successMsg);
                }
                $(theForm).find('.form-proccessing').hide();
                $(theForm).find('.form-success').show();
                $(theForm).find('button[data-dismiss="modal"]').text('×').show();
                $(theForm).removeClass('was-validated');
                break;
            case "fail":
                let msg = '<div class="alert alert-danger"><div class="text-danger"><strong>' + errorMsg + '</strong>';
                msg = msg + '<ul class="mb-0 pl-3">';
                $.each(errors, function(key, error) {
                    msg = msg + '<li>' + error + '</li>';
                });
                msg = msg + '</ul></div></div>';

                $(theForm).find('.form-errors').html(msg).show();
                $(theForm).find('.form-proccessing').hide();
                $(theForm).find('.form-content').show();
                $(theForm).find('.model-footer button, button[type="submit"]').show();
                $(theForm).addClass('was-validated');
                break;
            case "reset":
                $(theForm).find('.form-success').hide();
                $(theForm).find('.form-errors').hide();
                $(theForm).find('.form-proccessing').hide();
                $(theForm).find('.form-content').show();
                $(theForm).find('button[data-dismiss="modal"]').text('×').show();
                $(theForm).find('.model-footer button, button[type="submit"]').show();
                $(theForm).removeClass('was-validated');
                break;
            default:
                break;
        }
    }

    $.submitJsonPostForm = function(theForm, event) {

        event.preventDefault();

        const formData = theForm.serializeArray();
        $.handleModalFormStatus(theForm, 'processing', '', '', []);

        if(theForm && $(theForm).attr('action') && formData) {
            $.ajax({
                url: $(theForm).attr('action'),
                type: 'POST',
                data: formData,
                cache : false,
                headers: {
                    Accept: "application/json; charset=utf-8"
                },
                dataType: 'JSON'
            }).done(function(data, textStatus, jqXHR){
                let successMsg = data.message ? data.message : '';
                $.handleModalFormStatus(theForm, 'done', successMsg, '', []);
                return true;
            }).fail(function(xhr, error) {
                const responseData = $.parseJSON(xhr.responseText);
                //console.log(responseData);
                $.handleModalFormStatus(theForm, 'fail', '', responseData['message'], responseData['errors']);
                return false;
            });
        }
        return false;
    }

    $.confirmDeleteEntityModal = function(title, body) {
        const _modal = $('div#delete-entity-confirmation');
        $(_modal).find('.modal-title').html(title);
        $(_modal).find('.modal-body').html(body);
        $(_modal).modal('show');
        return false;
    }

    function pageLoaded() {
        const _forms = $('form');

        $.avoidDoubleClick();
        $.bindSubmitEvent(_forms);
        $.initUploadFields();
        $.initAutocompleteFields();
        $.initPopovers();

        $(this).find('.form-errors').hide();
        $(this).find('.form-proccessing').hide();
        $(this).find('.form-success').hide();

        $('input[type="tel"]').cstmFormatPhonenumber( {expression: /[^\+0-9- ]/g, removeDoubleChars: true} );

        //console.log('loaded ui-forms');
    }

    // add livewire navigated listener
    document.addEventListener('livewire:navigated', function () {
        pageLoaded();
    });

    // livewire is not installed
    if (typeof Livewire === "undefined") {
        // do jquery basic stuff after page has loaded
        $(function(){
            pageLoaded();
        });
    }

}( jQuery ));
